import { ConfigProvider, theme } from 'antd';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import { useTheme } from '../context/ThemeContext';
import { useLanguage } from '../i18n/provider';

const lightTokens = {
  colorPrimary: '#1e66f5',
  colorError: '#d20f39',
  colorSuccess: '#40a02b',
  colorWarning: '#df8e1d',
  colorLink: '#1e66f5',
  colorBgContainer: '#eff1f5',
  colorBgElevated: '#e6e9ef',
  colorBgLayout: '#dce0e8',
  colorText: '#4c4f69',
  colorTextSecondary: '#6c6f85',
  colorBorder: '#ccd0da',
  colorBorderSecondary: '#bcc0cc',
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif",
  borderRadius: 6,
};

const darkTokens = {
  colorPrimary: '#89b4fa',
  colorError: '#f38ba8',
  colorSuccess: '#a6e3a1',
  colorWarning: '#f9e2af',
  colorLink: '#89b4fa',
  colorBgContainer: '#1e1e2e',
  colorBgElevated: '#181825',
  colorBgLayout: '#11111b',
  colorText: '#cdd6f4',
  colorTextSecondary: '#a6adc8',
  colorBorder: '#313244',
  colorBorderSecondary: '#45475a',
  borderRadius: 6,
};

export default function AntdProvider({ children }: { children: React.ReactNode }) {
  const { theme: currentTheme } = useTheme();
  const { effectiveLocale } = useLanguage();
  const isDark = currentTheme === 'dark';

  return (
    <ConfigProvider
      locale={effectiveLocale === 'zh-CN' ? zhCN : enUS}
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: isDark ? darkTokens : lightTokens,
      }}
    >
      {children}
    </ConfigProvider>
  );
}
